<mat-dialog-content>
    <div class="spinner-center" *ngIf="loading">
        <mat-spinner></mat-spinner>
    </div>
    <ng-container *ngIf="!loading">
        <div class="div-row">
            <div class="title">
                <span
                    *ngIf="!data?.transferActionType || data?.transferActionType === TransferActionTypes.CreateTransfer">{{
                    'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.CREATE.TITLE' | translate |
                    uppercase
                    }}</span>
                <span *ngIf="data?.transferActionType === TransferActionTypes.ViewTransfer">{{
                    'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.VIEW.TITLE' | translate |
                    uppercase
                    }}</span>
                <span *ngIf="data?.transferActionType === TransferActionTypes.EditTransfer">{{
                    'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.EDIT.TITLE' | translate |
                    uppercase
                    }}</span>
                <span *ngIf="data?.transferActionType === TransferActionTypes.ValidateTransfer">{{
                    'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.VALIDATE.TITLE' | translate |
                    uppercase
                    }}</span>
                <span *ngIf="data?.transferActionType === TransferActionTypes.CatalogTransfer">{{
                    'DEUSTO.NEW_MENU.MENU_ITEMS.TRANSFERS.ACTIONS.CATALOG.DIALOG.TITLE' | translate |
                    uppercase
                    }}</span>

                <span *ngIf="udeuTransfer?.name as name" class="ml5">{{name}}</span>
            </div>
            <div class="action-buttons">
                <button mat-raised-button
                    [color]="data?.transferActionType === TransferActionTypes.ViewTransfer ? 'primary' : data?.transferActionType === TransferActionTypes.ValidateTransfer ? 'accent' : 'warn'"
                    (click)="closeDialog()">
                    <mat-icon>close</mat-icon>
                </button>

                <button
                    *ngIf="data?.transferActionType === TransferActionTypes.CreateTransfer || (data?.transferActionType === TransferActionTypes.EditTransfer && !canEditExtraProps)"
                    mat-raised-button [color]="canEditExtraProps ? 'primary' : 'accent'" [matTooltip]="canEditExtraProps
                                    ? 'Guardar transferencia' : 'Guardar transferencia como borrador' | translate"
                    [disabled]="canEditExtraProps ? mainFormGroup.invalid : false" (click)="createTransfer(true)">
                    <mat-icon>save</mat-icon>
                </button>

                <button
                    *ngIf="data?.transferActionType === TransferActionTypes.CreateTransfer || data?.transferActionType === TransferActionTypes.EditTransfer"
                    mat-raised-button color="primary" [matTooltip]="'Enviar transferencia' | translate"
                    [disabled]="mainFormGroup.invalid" (click)="createTransfer()">
                    <mat-icon>send</mat-icon>
                </button>

                <ng-container *ngIf="data?.transferActionType === TransferActionTypes.ValidateTransfer">
                    <button mat-raised-button color="warn" [matTooltip]="'Rechazar transferencia' | translate"
                        [disabled]="mainFormGroup.invalid"
                        (click)="changeStatusTransfer(UDEU_TRANSFER_REJECTED_STATUS)">
                        <mat-icon>block</mat-icon>
                    </button>
                    <button mat-raised-button color="primary" [matTooltip]="'Aceptar transferencia' | translate"
                        [disabled]="mainFormGroup.invalid"
                        (click)="changeStatusTransfer(UDEU_TRANSFER_ACCEPTED_STATUS)">
                        <mat-icon>check_circle</mat-icon>
                    </button>
                </ng-container>

                <button *ngIf="data?.transferActionType === TransferActionTypes.CatalogTransfer" mat-raised-button
                    color="primary" [matTooltip]="'Catalogar transferencia' | translate"
                    [disabled]="mainFormGroup.invalid" (click)="createTransfer()">
                    <mat-icon>archive</mat-icon>
                </button>
            </div>
        </div>
        <mat-stepper #matStepper orientation="horizontal" [linear]="false">
            <ng-container *ngIf="udeuService.getStepsFiltered(steps) as stepsList">
                <ng-container *ngFor="let step of stepsList; let i = index">
                    <ng-container *ngIf="step.form.group as formGroup">
                        <mat-step #matStep [stepControl]="formGroup" *ngIf="!step.disabled"
                            [completed]="isCompleted(matStep)">
                            <form [formGroup]="formGroup">
                                <ng-template matStepperIcon="edit"><mat-icon>check</mat-icon></ng-template>
                                <ng-template matStepperIcon="number"><mat-icon>none</mat-icon></ng-template>
                                <ng-template matStepLabel><span [matTooltip]="step.name | translate">{{step.name |
                                        translate
                                        }}</span></ng-template>
                                <div class="formDiv">
                                    <ng-container *ngIf="step.type === StepTypes.GENERIC; else special">
                                        <ng-container *ngFor="let controlName of udeuService.getObjectKeys(formGroup)">
                                            <ng-container *ngIf="step.form.fields[controlName] as formField">
                                                <ng-container *ngIf="!formField.disabled">
                                                    <div *ngIf="formField.type === MatFormFieldType.INPUT"
                                                        [ngStyle]="formField.style ? formField.style : { width: '45%'}">
                                                        <mat-form-field class="w100">
                                                            <mat-label>{{formField.label | translate}}</mat-label>
                                                            <textarea matInput cdkTextareaAutosize
                                                                [placeholder]="formField.placeholder | translate"
                                                                [formControlName]="controlName"></textarea>
                                                        </mat-form-field>
                                                    </div>

                                                    <smt-search-select [useChips] = "false"
                                                        *ngIf="formField.type === MatFormFieldType.SELECT"
                                                        [ngStyle]="formField.style ? formField.style : { width: '45%'}"
                                                        [group]="formGroup" [controlName]="controlName"
                                                        [label]="formField.label" [options]="formField.options"
                                                        (optionSelected)="udeuService.formFieldChangeFunc(formField, $event.option.value)"
                                                        (optionChanged)="udeuService.formFieldChangeFunc(formField, null)"></smt-search-select>

                                                    <smt-date-input *ngIf="formField.type === MatFormFieldType.DATE"
                                                        [ngStyle]="formField.style ? formField.style : { width: '45%'}"
                                                        [group]="formGroup" [controlName]="controlName"
                                                        [placeholder]="formField.placeholder"
                                                        [extraControlName]="formField.extraControlName"
                                                        [extraPlaceholder]="formField.extraPlaceholder"
                                                        [label]="formField.label"
                                                        [dateType]="DateType.RANGE_YEAR"></smt-date-input>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                    <ng-template #special>
                                        <ng-container *ngIf="step.type === StepTypes.DOCS_TO_TRANSFER">
                                            <alden-documents class="w100" [group]="docsToTransferFormGroup"
                                                [controlName]="'documents'"
                                                [support]="dataFormGroup.get('support').value"
                                                [udeuDocuments]="udeuTransfer?.documents"
                                                [canEditExtraProps]="canEditExtraProps" [actionType]="data?.transferActionType"></alden-documents>
                                        </ng-container>
                                        <ng-container *ngIf="step.type === StepTypes.FILES">
                                            <alden-attach-files class="w100" [group]="filesFormGroup"
                                                [controlName]="'files'"
                                                [udeuFiles]="udeuTransfer?.files"></alden-attach-files>
                                        </ng-container>
                                    </ng-template>
                                </div>
                                <div class="action-buttons" #actionDiv>
                                    <button *ngIf="i != 0" mat-raised-button matStepperPrevious color="primary">{{
                                        'ALDEN.STEPS_ACTIONS.PREVIOUS' | translate
                                        }}</button>
                                    <button *ngIf="i < stepsList.length-1" mat-raised-button matStepperNext
                                        color="primary">{{ 'ALDEN.STEPS_ACTIONS.NEXT'
                                        | translate }}</button>
                                </div>
                            </form>
                        </mat-step>
                    </ng-container>
                </ng-container>
            </ng-container>
        </mat-stepper>
    </ng-container>
</mat-dialog-content>